"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dialog = void 0;
var react_1 = __importStar(require("react"));
var react_dom_1 = require("react-dom");
var react_focus_lock_1 = __importDefault(require("react-focus-lock"));
var use_on_esc_1 = require("../../hooks/use-on-esc");
var set_body_props_mapper_1 = require("../../utils/mappers/set-body-props/set-body-props.mapper");
var styles_1 = require("./styles");
var modalRootContainer = document.querySelector('#modal-root');
var Dialog = function (_a) {
    var id = _a.id, header = _a.header, content = _a.content, className = _a.className, ariaLabel = _a.ariaLabel, onClickOutSide = _a.onClickOutSide, closeOnClick = _a.closeOnClick, center = _a.center, contentCenter = _a.contentCenter, width = _a.width, fixed = _a.fixed;
    (0, react_1.useEffect)(function () {
        (0, set_body_props_mapper_1.setBodyProps)({ overflow: 'hidden', ariaHidden: true, tabIndex: -1 });
        return function () {
            (0, set_body_props_mapper_1.setBodyProps)({ overflow: 'auto', ariaHidden: false });
        };
    }, []);
    (0, use_on_esc_1.useOnEsc)(onClickOutSide, closeOnClick);
    if (closeOnClick === undefined) {
        closeOnClick = true;
    }
    var component = (react_1.default.createElement(react_focus_lock_1.default, null,
        react_1.default.createElement(styles_1.DialogBgStyled, { onClick: onClickOutSide },
            react_1.default.createElement(styles_1.DialogSectionStyled, { role: "dialog", "data-testid": id, id: id, onClick: function (e) { return e.stopPropagation(); }, center: center, className: className, width: width, fixed: fixed, "aria-label": ariaLabel },
                react_1.default.createElement(styles_1.DialogHeaderStyled, null, header),
                react_1.default.createElement(styles_1.DialogContentStyled, { contentCenter: contentCenter }, content)))));
    if (modalRootContainer) {
        return (0, react_dom_1.createPortal)(component, modalRootContainer);
    }
    return component;
};
exports.Dialog = Dialog;
